import { infer as Infer, z } from 'zod';

export const postRecipientsEditSchema = z.object({
  groupIds: z.array(z.number()).optional(),
  add: z.boolean().optional(),
  remove: z.boolean().optional(),
});

export type PostRecipientsEditSchema = Infer<typeof postRecipientsEditSchema>;
